import {
  LINK_OPTION_CHECKED,
  LINK_OPTION_COPY_REACTION_FAILURE,
  LINK_OPTIONS_CLEAR,
  LINK_OPTIONS_CLOSE,
  LINK_OPTIONS_OPEN,
  LinkOptionType,
} from '@Pages/RetroSynthesis/LinkOption/constants';
import { showAddStepsDialog } from '@Pages/RetroSynthesis/EditPlan/AddSteps/actions';
import { deleteRouteSteps, setActiveStep, setConditionsIsShown } from '@Pages/RetroSynthesis/ProjectRoute/actions';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { noCache } from '@Utils/Network';
import { showCopiedToastMessage } from '@Containers/ToastMessages/CopiedToastMessage/CopiedToastMessageAction';
import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';
import { onStepDeleteConfirm } from '@Pages/RetroSynthesis/LinkOption/analytics';
import store from '@Store';

export const linkOptionsOpenAction = ({ targetRect, step }) => ({
  type: LINK_OPTIONS_OPEN,
  payload: {
    targetRect,
    step,
  },
});

export const linkOptionsCloseAction = () => ({
  type: LINK_OPTIONS_CLOSE,
});

export const linkOptionsClearAction = () => ({
  type: LINK_OPTIONS_CLEAR,
});

export const linkOptionCheckedAction = ({ optionType, step, projectId, routeId, projectInfo, routeType }) => {
  return async (dispatch) => {
    switch (optionType) {
      case LinkOptionType.SHOW_CONDITIONS:
        dispatch(setActiveStep(step.step));
        dispatch(setConditionsIsShown(true));
        break;
      case LinkOptionType.ADD_REACTION_STEP:
        dispatch(showAddStepsDialog(step));
        break;
      case LinkOptionType.COPY_REACTION:
        try {
          const response = await MessageBroker.send(
            RequestUrls.rsProjectsGetRouteStepMollFile,
            { projectId, routeId, step: step.step },
            noCache()
          );
          navigator.clipboard.writeText(response);
          showCopiedToastMessage();
        } catch (error) {
          dispatch({ type: LINK_OPTION_COPY_REACTION_FAILURE, payload: error });
        }
        break;
      case LinkOptionType.DELETE_PRIOR_STEPS:
        NotifyDialogsService.openModalWindow({
          title: 'Delete',
          text: 'Are you sure?',
          cancelText: 'No',
          confirmText: 'Yes',
          size: 'sm',
          type: 'info',
          backdrop: 'static',
          onConfirm: () => {
            store.dispatch(deleteRouteSteps(projectId, routeId, step.step));
            onStepDeleteConfirm({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
          },
        });
        break;
      default:
        dispatch({
          type: LINK_OPTION_CHECKED,
          payload: {
            optionType,
            step,
          },
        });
    }
  };
};
